module.exports = __webpack_public_path__ + "static/media/jw_red.df1f1ba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bottles/backgrounds/Templates/Previews/jw_red.jpg
// module id = 741
// module chunks = 0